import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'

import { cn } from '@/shared/lib/cn'

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-1.5 rounded-md font-medium whitespace-nowrap ' +
    'transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 ' +
    '[&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:pointer-events-none',
  {
    variants: {
      variant: {
        // 5.05:1 com branco — travado em contrast.test.ts
        primary: 'bg-action text-white hover:bg-action-hover active:bg-action-active',
        secondary: 'border border-line-strong bg-surface text-ink hover:bg-surface-2',
        outline: 'border border-action text-action hover:bg-action-bg', // o "Filtrar" do nibo
        ghost: 'text-ink-muted hover:bg-surface-2 hover:text-ink',
        link: 'text-action underline-offset-4 hover:underline',
        danger: 'bg-danger text-white hover:brightness-95',
      },
      size: {
        xs: 'h-6 px-2 text-2xs',
        sm: 'h-7 px-2.5 text-xs', // barra de filtro
        md: 'h-8 px-3 text-sm', // PADRÃO
        lg: 'h-10 px-4 text-base', // CTA de empty state
        icon: 'size-8 p-0',
      },
    },
    defaultVariants: { variant: 'secondary', size: 'md' },
  },
)

/**
 * `gold` NÃO é variante de botão: 2.40:1 com branco reprova até o piso de 3:1 de
 * componente (ver contrast.test.ts). O tipo impede o erro — não é convenção, é
 * impossível de escrever.
 */
export type ButtonProps = ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    /** Renderiza o filho no lugar do <button> (ex.: envolver um <Link>). */
    asChild?: boolean
  }

export function Button({ className, variant, size, asChild = false, ...props }: ButtonProps) {
  const Comp = asChild ? Slot : 'button'
  return <Comp className={cn(buttonVariants({ variant, size }), className)} {...props} />
}
